

const Home = () => {
    return (
        <div style={{padding: '30px'}}>
            <h1>Work in progress...</h1>
        </div>
    )
};

export default Home